import Http from "../network/Http";
import { fileUpload } from "../network/UploadService";
import { StorageService } from "../utils/StorageUtils";
import { getItemFromCache } from "../utils/wall/wall-constants";
import { WALL_MESSAGE_BANK } from "../utils/wall/wall-message-bank";

export const getActivities = async (inputBody) => {
  try {
    let queryParams = ``;
    for (let item of Object.keys(inputBody)) {
      queryParams += `${item}=${encodeURIComponent(inputBody[item])}&`;
    }
    queryParams = queryParams.slice(0, -1);
    let apiURL = `/api/school-hub/activities`;
    let response = Http.get(`${apiURL}?${queryParams}`);
    return response;
  } catch (e) {
    console.log(e);
    return {};
  }
};
export const getMyClassActivities = async (inputBody) => {
  try {
    let apiURL = `/schoolai/task/student-myclass-activity`;
    let response = Http.post(apiURL, JSON.stringify(inputBody));
    return response;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const fecthPostsByActivity = async (inputParms, studentDetails) => {
  try {
    let queryParams = ``;
    for (let item of Object.keys(inputParms)) {
      queryParams += `${item}=${encodeURIComponent(inputParms[item])}&`;
    }
    // Remove the trailing '&'
    queryParams = queryParams.slice(0, -1);
    let apiURL = `/api/school/activity/posts`;
    let response = Http.post(
      `${apiURL}?${queryParams}`,
      JSON.stringify(studentDetails)
    );
    return response;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const getUserPosts = async (limit = 10, offset = 0, sortType) => {
  try {
    let apiURL = `/api/v1/user/posts`;
    let queryParams = `limit=${limit}&offset=${offset}&sortType=${sortType}`;
    let response = Http.get(`${apiURL}?${queryParams}`);
    return response;
  } catch (e) {
    console.log(e);
    return {};
  }
};

export const getMessageBank = async () => {
  const response = Http.get(`/api/message-bank`);
  return response;
};

export const getRandomMessage = async (code) => {
  let apiURL = `/message-bank-service/configurations/messages/random`;
  let queryParams = `messagesBankCode=${code}&module=${WALL_MESSAGE_BANK}`;
  const response = await Http.get(`${apiURL}?${queryParams}`);
  return response;
};

export const uploadFile = async (files) => {
  let response = await fileUpload(files, "wall-service");
  return response;
};

export const createPost = async (inputData, activityId) => {
  let { files } = inputData;
  inputData.activityId = activityId;
  let attachments = [];
  let response = {};
  if (files?.length > 0) {
    attachments = await uploadFile(files);
  }
  response = await postWithoutFile(inputData, attachments);
  return response;
};

const postWithoutFile = async (inputData, attachments) => {
  let userId = StorageService.getItem("xUserId");
  let loginUser = await getItemFromCache("user_additional_details");
  let postObj = {
    userId: userId,
    postTitle: inputData?.title || "",
    postContent: inputData?.description || "",
    postLink: inputData?.links?.[0] || "",
    activityId: inputData?.activityId,
    attachments: attachments || [],
    color: inputData?.color || "#EEFCDD",
    schoolId: loginUser?.schoolId || "0",
    sectionId: loginUser?.sectionId || "0",
  };
  let response = await Http.post("/api/post", JSON.stringify(postObj));
  return response;
};

export const updatePost = async (inputData, activityId, postId, status, isBackClicked) => {
  let { files = [] } = inputData;
  let browsedFiles = files?.filter((item) => item.url == undefined) || [];
  let exisingFiles = files?.filter((item) => item.url != undefined);
  inputData.activityId = activityId;
  let attachments = [];
  let response = {};
  if (files?.length > 0) {
    attachments = await uploadFile(browsedFiles);
  }
  attachments = [...exisingFiles, ...attachments];
  console.log("attachments....", attachments);
  response = await updatePostWithoutFile(inputData, attachments, postId, status,isBackClicked);
  return response;
};

const updatePostWithoutFile = async (inputData, attachments, postId, status,isBackClicked) => {
  let userId = StorageService.getItem("xUserId");
  let loginUser = await getItemFromCache("user_additional_details");
  let postObj = {
    userId: userId,
    postTitle: inputData?.title || "",
    postContent: inputData?.description || "",
    postLink: inputData?.links?.[0] || "",
    attachments: attachments || [],
    color: inputData?.color || "#EEFCDD",
    activityId: inputData?.activityId,
    schoolId: loginUser?.schoolId || "0",
    sectionId: loginUser?.sectionId || "0",
    status: status,
    isBackClicked: isBackClicked
  };
  let response = await Http.put(`/api/post/${postId}`, JSON.stringify(postObj));
  return response;
};

export const getPostComments = async (postId) => {
  const response = Http.get(`/api/comment/post/${postId}`);
  return response;
};

export const saveComment = async (postId, activityId, comment) => {
  let queryObj = await getItemFromCache("user_additional_details");
  const data = {
    userId: queryObj?.userId,
    comment,
    postId,
    activityId,
    userName: queryObj?.firstName + " " + queryObj?.lastName,
    isStudent: true,
  };
  const response = Http.post(`/api/comment`, JSON.stringify(data));
  return response;
};

export const getActivityInteractionsCount = async (details) => {
  const { activityId, sectionId, schoolId } = details;
  const response = Http.get(
    `/api/post/interactions/${activityId}/${schoolId}/${sectionId}`
  );
  return response;
};

export const viewOnly = async (activityId) => {
  const response = Http.put(`/api/activity/${activityId}/quit`);
  return response;
};

export const updateClap = async (body) => {
  const response = Http.post(`/api/clap`, JSON.stringify(body));
  return response;
};
export const deletePost = async (postId) => {
  const response = Http.delete(`/api/post/${postId}`);
  return response;
};

export const hidePost = async (postId, inputData) => {
  const response = Http.put(
    `/api/post/${postId}/hide`,
    JSON.stringify(inputData)
  );
  return response;
};

export const getPendingVotes = async (activityId) => {
  const response = Http.get(`/api/votes/${activityId}`);
  return response;
};

export const saveTagtoPortfolio = async (postId) => {
  let inputData = {
    wallId: postId,
  };
  const response = await Http.post(
    `/portfolio-service/portfolio/wall`,
    JSON.stringify(inputData)
  );
  if (response?.success) {
    await Http.put(`/api/tag-to-portfolio/${postId}`);
  }
  return response;
};

export const saveSuggestToPortfolio = async (postId) => {
  let inputData = {
    wallId: postId,
  };
  const response = await Http.post(
    `/portfolio-service/portfolio/suggest`,
    JSON.stringify(inputData)
  );
  if (response?.success) {
    await Http.put(`/api/suggest-to-portfolio/${postId}`);
  }
  return response;
};

export const getPostById = async (postId) => {
  const response = Http.get(`/api/post/${postId}`);
  return response;
};